// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/bootstrap/css/bootstrap.min.css
// module id = 2130
// module chunks = 0